// extracted by mini-css-extract-plugin
module.exports = {"filterElements":"CQs6uMbC7GcYcOh8ApQn"};